import React from 'react';
import DeliveryOptions from './DeliveryOptions';
import KioskDeliveryTitle from './KioskDeliveryTitle';
import { Props } from './DeliveryComponent';
import Translation from '../../../../shared/Translation';
import { DeliveryOptionsSelect } from './DeliveryOptionsSelect';

const Delivery: React.FC<Props> = ({
  deliveryOptions,
  isKioskMode,
  singularDeliveryOption,
  onDeliveryChange,
  onDeliveryPhoneChange,
  onCountryCodeChange,
  onAddressChange,
  selectedOption,
  loading,
  phone,
  countryCode,
  address,
  kioskCollectCustomerEmail,
  onEmailChange,
  onMobileFocus,
  onEmailFocus,
  email,
  gatewayType,
  onPhoneClear,
}) => {
  const hasShippingMethods = deliveryOptions?.some((option) => option.requires_shipping);

  const showSelect = deliveryOptions.length > 1 && !hasShippingMethods;

  const deliveryHeaderTranslation = 'checkout__delivery_method';

  const hasPaidOption = deliveryOptions.some((option) => option.price && option.price.amount > 0);

  return (
    <section className="checkout-form__section">
      <fieldset className="form-card">
        <div className="form-card__header">
          {isKioskMode ? (
            !singularDeliveryOption && <KioskDeliveryTitle />
          ) : (
            <legend id="delivery-options__legend">
              <h4 className="form-card__heading">
                <Translation>{deliveryHeaderTranslation}</Translation>
              </h4>
            </legend>
          )}
        </div>
        <div className="form-card__content">
          {showSelect ? (
            <DeliveryOptionsSelect
              onDeliveryChange={onDeliveryChange}
              onDeliveryPhoneChange={onDeliveryPhoneChange}
              onCountryCodeChange={onCountryCodeChange}
              onAddressChange={onAddressChange}
              deliveryOptions={deliveryOptions}
              selectedOption={selectedOption}
              disabled={loading}
              phone={phone}
              countryCode={countryCode}
              address={address}
              isKioskMode={isKioskMode}
              kioskCollectCustomerEmail={kioskCollectCustomerEmail}
              onEmailChange={onEmailChange}
              onMobileFocus={onMobileFocus}
              onEmailFocus={onEmailFocus}
              email={email}
              singularDeliveryOption={singularDeliveryOption}
              gatewayType={gatewayType}
              hasPaidOption={hasPaidOption}
            />
          ) : (
            <div className="input">
              <div
                className={`delivery-option__input input__radios ${
                  singularDeliveryOption ? 'delivery__option--singular' : ''
                }`}
              >
                {deliveryOptions.map((option, i) => (
                  <DeliveryOptions
                    key={i}
                    delivery_option={option}
                    onDeliveryChange={onDeliveryChange}
                    onDeliveryPhoneChange={onDeliveryPhoneChange}
                    onCountryCodeChange={onCountryCodeChange}
                    onPhoneClear={onPhoneClear}
                    onAddressChange={onAddressChange}
                    price={option.price.amount}
                    selected={option.id === selectedOption}
                    phone={phone}
                    countryCode={countryCode}
                    address={address}
                    isKioskMode={isKioskMode}
                    kioskCollectCustomerEmail={kioskCollectCustomerEmail}
                    onEmailChange={onEmailChange}
                    onMobileFocus={onMobileFocus}
                    onEmailFocus={onEmailFocus}
                    email={email}
                    singularDeliveryOption={singularDeliveryOption}
                    gatewayType={gatewayType}
                    disabled={loading}
                    single={deliveryOptions.length === 1}
                    hasPaidOption={hasPaidOption}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </fieldset>
    </section>
  );
};

export default Delivery;
